import { render, staticRenderFns } from "./EstadoIntegraciones.vue?vue&type=template&id=2a992e0a&scoped=true&"
import script from "./EstadoIntegraciones.vue?vue&type=script&lang=ts&"
export * from "./EstadoIntegraciones.vue?vue&type=script&lang=ts&"
import style0 from "./EstadoIntegraciones.vue?vue&type=style&index=0&id=2a992e0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a992e0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2a992e0a', component.options)
    } else {
      api.reload('2a992e0a', component.options)
    }
    module.hot.accept("./EstadoIntegraciones.vue?vue&type=template&id=2a992e0a&scoped=true&", function () {
      api.rerender('2a992e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MID/EstadoIntegraciones.vue"
export default component.exports